import {Injectable, signal} from '@angular/core';

@Injectable({providedIn: 'root'})
export class SidebarService {
  private readonly _isCollapsed = signal(false);
  readonly isCollapsed = this._isCollapsed.asReadonly();

  toggleSidebar(): void {
    this._isCollapsed.update(value => !value);
  }

  closeSidebar(): void {
    this._isCollapsed.set(true);
  }

  openSidebar(): void {
    this._isCollapsed.set(false);
  }
}
